/**
 * Filter/label configurations — pure-data leaf (Perf 3.1.b Step 5).
 * Extracted from store/index.js so leaves (chat/collection) can import it
 * directly instead of relying on it being defined in the barrel.
 */
export const FILTER_CONFIGS = {
  collections: {
    sort: [
      { id: 'a-z', title: 'A to Z', icon: 'text', type: 'sort' },
      { id: 'z-a', title: 'Z to A', icon: 'text-outline', type: 'sort' },
      { id: 'newest', title: 'Newest', icon: 'time', type: 'sort' },
      { id: 'oldest', title: 'Oldest', icon: 'time-outline', type: 'sort' },
    ]
  },
  library: {
    filters: [
      { id: 'all', title: 'All', icon: 'apps', type: 'filter' },
      { id: 'archived', title: 'Archived', icon: 'archive', type: 'sort' },
      { id: 'shared', title: 'Shared', icon: 'share', type: 'sort' },
      { id: 'work', title: 'Work', icon: 'briefcase', type: 'filter' },
      { id: 'non-work', title: 'Non-work', icon: 'chatbubble', type: 'filter' },
    ],
    actions: [
      { id: 'delete', title: 'Delete', icon: 'delete', type: 'action' },
      { id: 'archive', title: 'Archive', icon: 'archive', type: 'action' },
      { id: 'add-to-collection', title: 'Add to collection', icon: 'folder-add', type: 'action' },
    ],
    sort: [
      { id: 'newest', title: 'Newest', icon: 'time', type: 'sort' },
      { id: 'oldest', title: 'Oldest', icon: 'time-outline', type: 'sort' },
    ]
  },
};
